import React from 'react' // eslint-disable-line no-unused-vars
import { RingLoader } from 'react-spinners'
import pdfIcon from './assets/pdf.png'
import { API_BASE_URL } from '../../index'
import DocumentModal from '../modals/DocumentModal'

class AttachDocuments extends React.Component {
  constructor (props) {
    super(props)
    this.DOCS_PER_PAGE = 6
    this.state = {
      currentPage: 0,

      // filter list
      products: [],
      categories: [],

      searchValue: '',

      // sort list
      sortColumn: '',
      sortDirection: '',

      documentOpened: false,
      documentLink: '',

      // this.props.documents contains all documents for a congress
      // this.state.documents is what gets displayed
      documents: this.paginate(props.documents)
    }
    // arrays representing which items have been checked/filtered
    this.filteredProduct = []
    this.filteredCategory = []
    this.getFilterList(
      props.documents,
      this.state.products,
      this.state.categories
    )
  }

  componentWillReceiveProps (props) {
    const products = []
    const categories = []
    this.getFilterList(props.documents, products, categories)
    const documents = this.paginate(
      props.documents
        .filter(document => {
          return this.checkSearchFieldMatch(document, this.state.searchValue)
        })
        .filter(this.filterDocList)
    )
    this.setState({ documents, products, categories })
  }

  clearFilter = () => {
    this.filteredProduct = []
    this.filteredCategory = []
    this.setState({
      documents: this.paginate(this.props.documents),
      searchValue: ''
    })
  };

  filterDocList = doc => {
    let matchedProduct = false
    if (this.filteredProduct.length === 0) {
      matchedProduct = true
    } else {
      doc.products.forEach(product => {
        if (this.filteredProduct.includes(product)) {
          matchedProduct = true
        }
      })
    }
    let matchedCategory = false
    if (this.filteredCategory.length === 0) {
      matchedCategory = true
    } else {
      doc.categories.forEach(category => {
        if (this.filteredCategory.includes(category)) {
          matchedCategory = true
        }
      })
    }
    return matchedProduct && matchedCategory
  };

  handleCheckbox = (event, type) => {
    const filteredType = 'filtered' + type
    const val = event.target.value
    if (this[filteredType].includes(val)) {
      this[filteredType] = this[filteredType].filter(item => {
        return item !== val
      })
    } else {
      this[filteredType] = [...this[filteredType], val]
    }
    this.setState({
      currentPage: 0,
      documents: this.paginate(
        this.props.documents
          .filter(document => {
            return this.checkSearchFieldMatch(document, this.state.searchValue)
          })
          .filter(this.filterDocList)
      )
    })
  };

  handlePageForward = () => {
    this.setState(prevState => ({
      currentPage:
        prevState.currentPage === this.props.documents.length - 1
          ? prevState.currentPage
          : prevState.currentPage + 1
    }))
  };

  handlePageBackward = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage === 0 ? 0 : prevState.currentPage - 1
    }))
  };

  handlePageNav = currentPage => {
    this.setState({ currentPage })
  };

  getFilterList = (documents, products, categories) => {
    documents.forEach(document => {
      document.products.forEach(product => {
        if (!products.includes(product)) {
          products.push(product)
        }
      })
      document.categories.forEach(category => {
        if (!categories.includes(category)) {
          categories.push(category)
        }
      })
    })
    products.sort()
    categories.sort()
  };

  openDocument = documentNumber => {
    const documentLink = encodeURI(
      `${API_BASE_URL}kiosk/view/${documentNumber}?country=${this.props.country}&congress=${this.props.conference}`
    )
    this.setState({ documentLink })
  };

  closeDocumentModal = () => {
    this.setState({ documentLink: null })
  };

  paginate = response => {
    if (response.length <= this.DOCS_PER_PAGE) {
      return [response]
    }
    const sorted = []
    let intermediateArr = []
    let i = 0
    for (const idx in response) {
      intermediateArr.push(response[idx])
      if (i === this.DOCS_PER_PAGE - 1) {
        sorted.push(intermediateArr)
        i = 0
        intermediateArr = []
      } else {
        i++
      }
    }
    intermediateArr.length !== 0 && sorted.push(intermediateArr)
    return sorted
  };

  checkSearchFieldMatch = (document, searchValue) => {
    return (
      document.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      (document.keywords &&
        document.keywords.toLowerCase().includes(searchValue.toLowerCase()))
    )
  };

  handleSearch = event => {
    const searchValue = event.target.value
    const filteredResult = this.props.documents.filter(document => {
      return this.checkSearchFieldMatch(document, searchValue)
    })
    this.setState({
      documents: this.paginate(filteredResult.filter(this.filterDocList)),
      currentPage: 0,
      searchValue
    })
  };

  sort = sortColumn => {
    this.setState(() => {
      let documents = this.props.documents.filter(document => {
        return this.checkSearchFieldMatch(document, this.state.searchValue)
      })

      let sortDirection = 'down'
      documents.sort((a, b) => {
        if (
          this.state.sortColumn !== sortColumn ||
          this.state.sortDirection === 'up'
        ) {
          if (a[sortColumn] < b[sortColumn]) {
            return -1
          }
          if (a[sortColumn] > b[sortColumn]) {
            return 1
          }
        } else {
          sortDirection = 'up'
          if (a[sortColumn] > b[sortColumn]) {
            return -1
          }
          if (a[sortColumn] < b[sortColumn]) {
            return 1
          }
        }
        return 0
      })
      documents = this.paginate(documents.filter(this.filterDocList))
      return {
        documents,
        sortColumn,
        sortDirection
      }
    })
  };

  render () {
    const handleCart = this.props.onCart

    return (
      <div id='attach-docs-container'>
        {this.props.loading === true ? (
          <RingLoader color='#071d49' loading />
        ) : this.props.documents.length !== 0 ? (
          <div>
            <h1 className='title'>
              {`Documents (${this.props.documents.length})`}
              <div id='attach-docs-search'>
                <input
                  id='attach-docs-input'
                  className='search'
                  type='text'
                  value={this.state.searchValue}
                  onChange={this.handleSearch}
                  placeholder='Search by File Name or Keyword'
                />
                <span className='fa fa-search' />
              </div>
            </h1>
            <FilterList
              products={this.state.products}
              categories={this.state.categories}
              filteredProduct={this.filteredProduct}
              filteredCategory={this.filteredCategory}
              onCheckbox={this.handleCheckbox}
              clearFilter={this.clearFilter}
            />
            <DocumentsList
              documents={this.state.documents[this.state.currentPage]}
              filterActive={
                this.filteredProduct.length !== 0 ||
                this.filteredCategory.length !== 0
              }
              onCart={handleCart}
              cart={this.props.cart}
              sort={this.sort}
              sortColumn={this.state.sortColumn}
              sortDirection={this.state.sortDirection}
              openDocument={this.openDocument}
              searchValue={this.props.searchValue}
            />
            <PageNav
              onPageNav={this.handlePageNav}
              onPageBackward={this.handlePageBackward}
              onPageForward={this.handlePageForward}
              currentPage={this.state.currentPage}
              pages={this.state.documents.length}
            />
            {this.state.documentLink ? (
              <DocumentModal
                documentLink={this.state.documentLink}
                closeDocumentModal={this.closeDocumentModal}
              />
            ) : null}
          </div>
        ) : (
          'No documents found'
        )}
      </div>
    )
  }
}

/*
  takes in an array (props.array)
  iterates and generates checkboxes
*/
function Checkboxes (props) {
  const checkboxes = props.array.map((value, index) => {
    return (
      <li key={index}>
        <label className='custom-control custom-checkbox mr-0'>
          <input
            id={`${props.title}-checkbox${index}`}
            type='checkbox'
            className='custom-control-input'
            value={value}
            checked={props.filteredItems.includes(value)}
            onChange={e => props.onCheckbox(e, props.title)}
          />
          <span className='custom-control-indicator' />
          <span className='custom-control-description'>{value}</span>
        </label>
      </li>
    )
  })
  return (
    <div>
      <div className='list-title'>{props.title}</div>
      <ul>{checkboxes}</ul>
    </div>
  )
}

function FilterList (props) {
  const handleClearFilter = props.clearFilter
  const handleCheckbox = props.onCheckbox

  return (
    <div className='filter-list'>
      <div className='header'>Filters</div>
      <div className='clear' onClick={handleClearFilter}>Clear Filters</div>
      <Checkboxes
        array={props.products}
        title='Product'
        onCheckbox={handleCheckbox}
        filteredItems={props.filteredProduct}
      />
      <Checkboxes
        array={props.categories}
        title='Category'
        onCheckbox={handleCheckbox}
        filteredItems={props.filteredCategory}
      />
    </div>
  )
}

function DocumentsList (props) {
  let documentsList = props.documents.map((document, index, arr) => {
    return (
      <div key={document.number}>
        <div className='row'>
          <div className='col-1'>
            <img className='pdf-icon' src={pdfIcon} alt='PDF' />
          </div>
          <a
            className='col-5 filename'
            role='button'
            onClick={() => props.openDocument(document.number)}
          >
            {document.name}
          </a>
          <div className='col-2 doc-col'>{document.products.join(', ')}</div>
          <div className='col-3 doc-col'>{document.categories.join(', ')}</div>
          <div className='col-1'>
            <button
              id={`button-${index}`}
              className={
                props.cart.includes(document.number)
                  ? 'btn doc-remove'
                  : 'btn doc-add'
              }
              type='button'
              onClick={() => props.onCart(document.number)}
            >
              <span
                className={
                  props.cart.includes(document.number)
                    ? 'fa fa-minus'
                    : 'fa fa-plus'
                }
              />
            </button>
          </div>
        </div>
        {index !== arr.length - 1 ? <hr /> : null}
      </div>
    )
  })
  if (
    documentsList.length === 0 &&
    (props.filterActive || !props.searchValue)
  ) {
    if (props.filterActive) {
      documentsList = (
        <div className='filter-empty'>
          {'There are no documents available that match your current filter selection. Please update your filters.'}
        </div>
      )
    } else if (!props.searchValue) {
      documentsList = (
        <div className='filter-empty'>
          {'There are no documents available that match what you entered. Please try again.'}
        </div>
      )
    }
  }
  return (
    <div className='doc-list'>
      <div className='row header'>
        <div
          className='col-6'
          onClick={() => {
            props.sort('name')
          }}
        >
          {'File Name '}
          <span
            className={`fa fa-sort${
              props.sortColumn === 'name' && props.sortDirection !== ''
                ? '-' + props.sortDirection
                : ''
            }`}
          />
        </div>
        <div
          className='col-2'
          onClick={() => {
            props.sort('products')
          }}
        >
          {'Product '}
          <span
            className={`fa fa-sort${
              props.sortColumn === 'products' && props.sortDirection !== ''
                ? '-' + props.sortDirection
                : ''
            }`}
          />
        </div>
        <div
          className='col-3'
          onClick={() => {
            props.sort('categories')
          }}
        >
          {'Category '}
          <span
            className={`fa fa-sort${
              props.sortColumn === 'categories' && props.sortDirection !== ''
                ? '-' + props.sortDirection
                : ''
            }`}
          />
        </div>
      </div>
      {documentsList}
    </div>
  )
}

function PageNav (props) {
  const handlePageBackward = props.onPageBackward
  const handlePageForward = props.onPageForward

  const isFirstPage = props.currentPage === 0
  const isLastPage = props.currentPage === props.pages - 1
  const pageNav = []
  for (let index = 0; index < props.pages; index++) {
    index > props.currentPage - 5 &&
      pageNav.length < 5 &&
      pageNav.push(
        index === props.currentPage ? (
          <span className='pageNavCenter' key={index}>
            <b className='centerCurrent'>{index + 1}</b>
          </span>
        ) : (
          <span className='pageNavCenter' key={index}>
            <span
              className='centerContent'
              onClick={() => props.onPageNav(index)}
            >
              {index + 1}
            </span>
          </span>
        )
      )
  }

  pageNav.unshift(
    <span className='pageNavLeft' key='left'>
      {!isFirstPage ? (
        <span className='leftContent' onClick={handlePageBackward}>
          {'<'}
        </span>
      ) : (
        <span className='arrowDisabled'>{'<'}</span>
      )}
    </span>
  )

  pageNav.push(
    <span className='pageNavRight' key='right'>
      {!isLastPage ? (
        <span className='rightContent' onClick={handlePageForward}>
          {'>'}
        </span>
      ) : (
        <span className='arrowDisabled'>{'>'}</span>
      )}
    </span>
  )

  return <div className='pageNav'>{pageNav}</div>
}

export default AttachDocuments



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/AttachDocuments.js